import { faRectangleAd } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateAdForm } from '~/components/forms/AdForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';
import { Breadcrumbs } from '../molecules/Breadcrumbs';
import { AppBreadcrumbs } from '../organisms/Breadcrumbs';

export type IAppCreateAdPageProps = {
  appId: string;
};

export const AppCreateAdPage: React.FC<IAppCreateAdPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parentUrl = `/apps/${appId}/ads`;

  return (
    <>
      <Helmet>
        <title>{t('AppCreateAdPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faRectangleAd} />
          {t('AppAdsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading title={t('AppCreateAdPage.title')} previousUrl={parentUrl} />

      <CreateAdForm
        appId={appId}
        onSuccess={() => navigate(parentUrl)}
        cancelUrl={parentUrl}
      />
    </>
  );
};
